import { Box, Text } from '@chakra-ui/react';

export type LabeledToastProps = {
  label?: string;
  message: string;
};

const LabeledToast = ({ label, message }: LabeledToastProps) => {
  return (
    <Box style={{ display: 'grid', gap: 4 }}>
      {label && (
        <Text fontWeight={600} fontSize={14}>
          {label}
        </Text>
      )}
      <Text fontSize={14} fontWeight={400}>{message}</Text>
    </Box>
  );
};

export default LabeledToast;
